import React from 'react';

const SuspenseFallback = () => (
  <div className="suspense-fallback">
    <div className="suspense-sidebar" />
    <div className="suspense-main">
      <div className="suspense-topbar" />
      <div className="suspense-content">
        <div className="spinner" />
      </div>
    </div>
  </div>
);

export default SuspenseFallback;
